/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import { motion } from 'framer-motion'
import React,{useState,useEffect} from 'react'
import OfferToolTip from '../../../Components/OfferToolTip'
import IndividualDiscountTooltip from './IndividualDiscountTootTip'
import Progressbar from './ProgressBar'

function IndividualCriteriaSummary({prodItem,
    setsearchValue,
    specialCartList,
    setshowProducts,
    showNotMaching,
    criteriaObject,
    i,
    GetCartCount,
    setselectedCriteria,
    OrderValue,
    handleDiscount,
    ViewBulkOffer,
    updateAmount,
    setupdateAmount,
    GetOfferData,
    offerData}) {
    const {items} =ViewBulkOffer
    const criteria = criteriaObject[i]
    const [hover, sethover] = useState('')
    useEffect(() => {
    }, [criteriaObject,specialCartList])
    
    return (
        <div className={`lg:min-w-[25%] w-full bg-[#E9EDF4] border-2 border-[#E9EDF4] h-auto rounded-lg p-6 lg:mt-0 mt-5 mb-3.5 ml-2`}>
            <p className="text-[#090406] text-xs font-semibold">Cart Criteria {i+1}</p>
            <div className="relative">
                <div className=" mt-2 mb-4">
                    <div className="flex justify-center items-center">
                        <div x-data="range()" x-init="mintrigger(); maxtrigger()" className="relative max-w-xl w-full">
                            {criteria?.OFFER_PARAMETER==="quantity"?
                                <Progressbar 
                                    max={Number(prodItem[i].MIN_QUANTITY)||0}
                                    min={0}
                                    chnaging={criteria?.total}
                                    GetOfferData={GetOfferData}
                                    offerData={offerData}
                                    criteriaObject={criteriaObject}
                                    OrderValue={criteria?.quantity}
                                    updateAmount={updateAmount}
                                    setupdateAmount={setupdateAmount}
                                    qunatity={true}
                                    i={i}/>:
                                <Progressbar 
                                    max={Number(prodItem[i].MIN_VALUE)||0}
                                    min={0}
                                    chnaging={OrderValue}
                                    GetOfferData={GetOfferData}
                                    offerData={offerData}
                                    criteriaObject={criteriaObject}
                                    OrderValue={criteria?.total}
                                    updateAmount={updateAmount}
                                    setupdateAmount={setupdateAmount}
                                    i={i}/>}
                        </div>
                    </div>
                </div>
                
                {/* <div>
                            <div className="flex justify-between mb-1">
                                <span className="text-base font-medium text-blue-700 dark:text-white">Flowbite</span>
                                <span className="text-sm font-medium text-blue-700 dark:text-white">45%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                <div className="bg-blue-600 h-2.5 rounded-full" style="width: 45%"></div>
                            </div>
                        </div> */}
                {criteria?.OFFER_PARAMETER && <div className="pb-0 flex justify-between"> 
                    <p className="text-xs font-semibold text-[#000000]">{criteria?.OFFER_PARAMETER==='quantity'?<>
                        {Number(criteria?.MIN_QUANTITY)}</>:<>{Number(criteria?.MIN_VALUE).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    })||0}</>}</p>
                </div>}
            </div>
            <p className="pt-4 font-semibold text-[#090406] text-xs">Quantity</p>
            <div className="flex justify-between items-center pt-2">
                <p className="font-normal text-[#555259] text-xs5">Line Items selected</p>
                <p className="font-normal text-base text-[#555259]">{criteria?.items}</p>
            </div>
            <div className="flex justify-between items-center mt-2">
                <p className="font-normal text-[#555259] text-xs5">Total Order Quantity</p>
                <p className="font-normal text-base text-[#555259]">{criteria?.quantity}</p>
            </div>
            <p className="mt-1 font-semibold text-[#090406] text-xs">Summary</p>
            <div className="flex justify-between items-center pt-2">
                <p className="text-xs5 font-normal text-[#555259]">Order value</p>
                <p className="font-normal text-base text-[#555259]">{criteria?.total && Number(criteria?.total).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                })}</p>
            </div>
            <div className="flex justify-between items-center mt-2">
                <div className="flex items-center">
                    <p className="text-xs5 font-normal text-[#555259]">Discount</p>
                    <span className="ml-1"  onMouseEnter={()=>{
                        setTimeout(() => {
                            sethover('active')
                        }, 1000);
                    }} onMouseLeave={()=>{
                        setTimeout(() => {
                            sethover('')
                        }, 2000);
                    }}onClick={()=>sethover('active')}>
                        <button
                            data-tooltip-target="tooltip-discountPrice1" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                            <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                        </button>
                        {showNotMaching ==='' && hover !=='' &&(
                            <IndividualDiscountTooltip hover={hover !==''} prod={criteria} i={i}/>
                        )}
                    </span>
                </div>
                <p className="font-normal text-base text-[#555259]">{showNotMaching===''?parseFloat(criteria?.discount||0).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                }):''}</p>
            </div>
            <div className="flex justify-between items-center mt-2">
                <p className="text-xs5 font-bold text-[#555259]">Net Amount</p>
                <p className="font-bold text-base text-[#555259]">{showNotMaching===''?Number(criteria?.total - criteria?.discount||0).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                }):''}</p>
            </div>
            <button
                disabled={i+1 >= items.product_criterion.length}
                onClick={()=>{
                    setselectedCriteria(i+1);
                    setshowProducts(false);
                    setsearchValue('')
                }}
                type="button" className={`w-full ${i+1 >= items.product_criterion.length?'bg-[#A5A5A5]':'bg-[#555259] cursor-pointer'} rounded-[8px] text-[#FFFFFF] text-sm font-semibold py-3 mt-2`}>
                Next Criteria
            </button>
        </div> 
    )
}

export default IndividualCriteriaSummary